import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import ProviderDistributionChart from "@/shared/components/dashboard/ProviderDistributionChart";
import AdminTransactionTable from "@/shared/components/admin/AdminTransactionTable";
import AreaStatsChart from "@/shared/components/dashboard/TransactionChart";

const COLORS = ["#0ea5e9", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444"];

export default function AnalyticsTab({
  chartData,
  providerData,
  transactions,
  txLoading,
  onView,
  merchants,
  resellers,
  t,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Volume Chart */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="lg:col-span-2"
      >
        <AreaStatsChart data={chartData} currency="Rs" title={t("volumeTrend7Days")} />
      </motion.div>

      <ProviderDistributionChart 
        data={providerData}
        colors={COLORS}
      />

      {/* Recent Transactions */}
      <div className="lg:col-span-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle>{t("recent20Transactions")}</CardTitle>
          </CardHeader>
          <CardContent>
            <AdminTransactionTable
              transactions={transactions.slice(0, 20)}
              isLoading={txLoading}
              onView={onView}
              compact
              merchants={merchants}
              resellers={resellers}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
